


























import { defineComponent } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { OlbTooltip, OlbButton } from '@olbbank/vue-components';

const { useState, useActions } = createNamespacedHelpers('loginStore');

export default defineComponent({
	components: { OlbTooltip, OlbButton },
	props: {
		isTooltipDisabled: {
			type: Boolean,
			default: false,
		},
	},
	setup() {
		const { isLoggedIn, hasReadTip } = useState(['isLoggedIn', 'hasReadTip']);
		const { updateHasReadTip } = useActions(['updateHasReadTip']);
		function setTip(value: boolean) {
			updateHasReadTip(value);
		}
		return {
			isLoggedIn,
			hasReadTip,
			setTip,
		};
	},
});
